<template>
  <div class="a-toggle-primary">
    <label :class="`a-toggle-switch-primary ${switchClass}`">
      <input
        :checked="value"
        v-bind="$attrs"
        @change="updateValue"
      >
      <span :class="sliderPrimaryClass"></span>
      <span
        v-if="text.length"
        class="a-toggle-text-primary"
      >
        {{ text }}
      </span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'AtomTogglePrimary',
  inheritAttrs: false,

  props: {
    elementId: [Number, String],
    method: {
      type: String,
      default: ''
    },
    showLoading: {
      type: Boolean,
      default: false
    },
    sliderClass: String,
    switchClass: {
      type: String,
      default: 'a-toggle-switch-center-primary'
    },
    text: {
      type: String,
      default: ''
    },
    value: [Boolean, Number]
  },

  computed: {
    sliderPrimaryClass () {
      return (this.showLoading || this.showLoading === 1)
        ? `a-toggle-slider-primary a-toggle-slider-loading-primary ${this.sliderClass}`
        : `a-toggle-slider-primary ${this.sliderClass}`
    }
  },

  methods: {
    updateValue (event) {
      if (this.method.length) {
        this.$emit('input', +event.target.checked)
        this.$emit(this.method, { id: this.elementId, state: +event.target.checked })
      } else {
        this.$emit('input', +event.target.checked)
      }
    }
  }
}
</script>
